import { all, put, call, takeLatest, takeEvery } from 'redux-saga/effects'
import axios from 'portal/utils/axios-msal'

import {
  SNIPPETS_LOAD,
  SNIPPET_RELEVANCE_FEEDBACK,
  SnippetsLoadAction,
  snippetsLoadFailure,
  snippetsLoadSuccess,
  SnippetRelevanceFeedbackAction
} from './actions'

function getBaseURI(
  accountId: string,
  projectId: string,
  moduleName: string,
  recordId: string
) {
  return (
    '/accounts/' +
    accountId +
    '/projects/' +
    projectId +
    '/modules/' +
    moduleName +
    '/records/' +
    recordId
  )
}

function* snippetsLoadSaga(action: SnippetsLoadAction) {
  const { accountId, projectId, moduleName, recordId } = action
  try {
    let snippets = {}
    const response: { data: any } = yield call(() =>
      axios.get(
        `${getBaseURI(accountId, projectId, moduleName, recordId)}/designmatches`
      )
    )

    snippets = response && response.data ? response.data : {}

    yield put(snippetsLoadSuccess(snippets))
  } catch (error) {
    yield put(snippetsLoadFailure(error as Error))
  }
}

function* snippetRelevanceFeedbackSaga(action: SnippetRelevanceFeedbackAction) {
  const {
    accountId,
    projectId,
    moduleName,
    recordId,
    productId,
    matchId,
    relevance,
    userId
  } = action
  try {
    yield call(() =>
      axios.put(
        `${getBaseURI(accountId, projectId, moduleName, recordId)}/products/${productId}/designmatches/${matchId}/relevance`,
        { relevance, userId }
      )
    )
  } catch (error) {
    console.error('ERROR:', error)
  }
}

export function* watch() {
  yield all([takeLatest(SNIPPETS_LOAD, snippetsLoadSaga)])
  yield takeEvery(SNIPPET_RELEVANCE_FEEDBACK, snippetRelevanceFeedbackSaga)
}
